/* global  showProductTypes, defaultProductSlug, prices, isPrintPhotoPage, allProductOptions */

import 'tooltipster';
import * as Handlebars from 'handlebars';
import * as common from './common';
import { updateTreesCounter } from './donationToTrees';
import { initializeProducts } from './selectProduct';
import { initializeProductDetails } from './productDetails';
import { initCropperIfNecessary } from './customizePrint';

const $window = $(window);
const $wallPicture = $('.photo-on-wall');
let wallPictureOriginalW = 0;
let wallPictureOriginalH = 0;
let photoData;
let currency = 'EUR';
let productExists = false;
const treeCost = 0.18;
const displayTreeNumberElement = document.querySelector('.c-trees__counter');
let costs = {
  price: 0,
  donation: 0,
};
const productTypes = {
  1: 'alu-dibond',
  2: 'acrylic-glass',
  3: 'canvas',
  4: 'fine-art-paper',
  5: 'poster',
  6: 'hahnemuhle_paper',
  7: 'framed-poster',
};
let selectedProduct = {};
const selectedProductValues = {
  actualProduct: {
    id: null, price: null, priceWithWoodenFrame: null, withWoodenFrame: null,
  },
  type: { id: 1, text: null }, // default starting product
  size: {
    id: null,
    text: null,
    targetCmHeight: null,
    targetCmWidth: null,
    targetHeight: null,
    targetWidth: null,
    unit: null,
  },
  option: { id: null, text: null },
  extraOption: { id: null, text: null },
  woodenFrameColor: { id: null, text: null, slug: null },
  passepartoutFrameColor: { id: null, text: null, slug: null },
};

const productSizeSelect = '#select-product-size';
const productTypeSelect = '.select-product-type';
const productFrameSelect = '.select-product-frame';
const $productSizeSelect = $(productSizeSelect);
const $productTypeSelect = $(productTypeSelect);
const $productFrameSelect = $(productFrameSelect);
const productOptionSelect = '.select-product-option';
const productExtraOptionSelect = '.select-product-extra-option';
const passepartoutFrameColorSelect = '.select-passepartout-radio';
const photoOnWallContainer = '.photo-on-wall-container';
const $photoOnWallContainer = $(photoOnWallContainer);
const resetOptions = function () {
  selectedProductValues.option.id = null;
  selectedProductValues.option.text = null;
  selectedProductValues.extraOption.id = null;
  selectedProductValues.extraOption.text = null;
  selectedProductValues.woodenFrameColor.id = null;
  selectedProductValues.woodenFrameColor.slug = null;
  selectedProductValues.woodenFrameColor.text = null;
  selectedProductValues.passepartoutFrameColor.id = null;
  selectedProductValues.passepartoutFrameColor.text = null;
  selectedProductValues.passepartoutFrameColor.slug = null;
};
/*
const updateProjectSupportText = function () {
  const newText = donationText.replace('%project_donation%', totalDonationPercentage);
  $('.js-photo-donation-text').html(newText);
};
*/

const displayCosts = function () {

  $('#product-id-submit').val(selectedProductValues.actualProduct.id);
  $('#extra-option-id-submit').val(selectedProductValues.extraOption.id);
  $('#with-wooden-frame-submit').val(selectedProductValues.actualProduct.withWoodenFrame);
  $('#wooden-frame-color-id-submit').val(selectedProductValues.woodenFrameColor.id);

  if (!isNaN(costs.price) && costs.price > 0) {
    const formattedPrice = common.formatPrice(costs.price);



    //updateProjectSupportText();
    updateTreesCounter(costs.total_donation);
    $('.js-show-price, .buy-photo-button-price').html(formattedPrice);
  }


  if (is_photo_discount_available && !isNaN(costs.price_before_discount)) {
    //console.log("photo discount debug");
    //console.log(costs);
    const originalFormattedPrice = common.formatPrice(costs.price_before_discount);
    $('.js-show-price-original, .buy-photo-button-price-original').html(originalFormattedPrice);
  }
};

const setDefaultProductOptions = function () {
  const firstProductType = Object.keys(allProductOptions)[0];
  selectedProduct = allProductOptions[firstProductType];
};
const triggerSliderChange = function () {
  $('.photo-page-thumbnail-wrap.preview-on-wall').trigger('click');
};
const changeSliderItem = function () {
  const thumbIndex = $(this).index();
  $('.js-photo-thumb-nav.is-selected').removeClass('is-selected');
  $(this).addClass('is-selected');
  $('.slider-element.active').removeClass('active');
  const el = $('.slider-element').get(thumbIndex);
  $(el).addClass('active');

  /*
  if( $(this).hasClass('is-mockup') )
  {
    $("#mockup-" + $(this).data('mockup-id') ).attr('src', $(this).data('mockup-src'));
  }
  */
};

const loadProductSizesTemplate = function () {
  const view = selectedProduct;
  const template = $('#product-sizes-template').html();
  const rendered = Handlebars.compile(template);
  const htmlTemplate = rendered(view);

  $('#select-product-size').html(htmlTemplate);
};
const loadProductVideoTemplate = function () {
  if (selectedProduct) {
    let view = selectedProduct.product_info.videos;
    let template = $('#product-video-template').html();
    let rendered = Handlebars.compile(template);
    let htmlTemplate = rendered(view);
    $('.slider-element.product-video').html(htmlTemplate);
    let videoId = view.videoId;
    let videoThumb = `//i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
    $('.product-video-preview-img').attr('src', videoThumb);

    if (view.hasOwnProperty('floaterFramesVideoId')) {
      template = $('#product-with-frame-video-template').html();
      rendered = Handlebars.compile(template);
      htmlTemplate = rendered(view);
      $('.slider-element.product-with-frame-video').html(htmlTemplate);
      videoId = view.floaterFramesVideoId;
      videoThumb = `//i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
      $('.product-with-frame-video-preview-img').attr('src', videoThumb);
      $('.photo-page-product-with-frame-video').show();
    } else {
      $('.slider-element.product-with-frame-video').empty();
      $('.photo-page-product-with-frame-video').hide();
    }
    common.smartYoutubeEmbed();
  }

};
const loadProductTypesGridTemplate = function () {
  // I use products to cycle inside the handlebars template
  const view = { products: allProductOptions };
  const template = $('#product-types-template').html();
  const rendered = Handlebars.compile(template);
  const htmlTemplate = rendered(view);

  $('.photo-page-product-types-grid').html(htmlTemplate);
};
const loadProductTypesTooltipTemplate = function () {
  const view = { products: allProductOptions };
  const template = $('#product-tooltips-template').html();
  const rendered = Handlebars.compile(template, { noEscape: true });
  const htmlTemplate = rendered(view);
  $('.tooltip-contents').html(htmlTemplate);


};
const loadProductTypesSidebarTemplate = function () {
  const view = { products: allProductOptions };
  const template = $('#product-sidebars-template').html();
  const rendered = Handlebars.compile(template, { noEscape: true });
  const htmlTemplate = rendered(view);
  $('.sidebar-contents').html(htmlTemplate);
};

const loadProductOptionsTemplate = function () {
  if (selectedProduct) {
    const product = productTypes[selectedProduct.product_info.id];
    const template = $('#product-options-template').html();
    const view = allProductOptions[product];
    const rendered = Handlebars.compile(template);
    const htmlTemplate = rendered(view);
    $('.photo-page-selected-product-options').html(htmlTemplate);
  }

};
const hideAllCurrentProductOptions = function () {
  $('.photo-page-all-options-wrap').addClass('is-hidden');
};
const initSidebar = function () {
  $('.c-product-customizer__error').html($('.c-product-customizer__error').data('text'));
  //const disclaimer = $('.project-donation-disclaimer').data('text');
  //let newText = disclaimer.replace('%project_donation%', totalDonationPercentage);
  //TODO: this can be done better
  /*
  if (!isPrintPhotoPage) {
    newText = newText.replace('%artist_name%', `${photoData.first_name} ${photoData.last_name}`);
  }
  */
  //$('.project-donation-disclaimer').html(newText);

  //updateProjectSupportText();
  hideAllCurrentProductOptions();
};

const photoOptions = {
  unit: 'cm',
  targetWidth: null,
  targetHeight: null,
  product: {
    typeId: null,
    availableWithFrame: null,
    extraOptionId: null, // $productExtraOptionSelect.val(), // maybe I can do the same with option
    woodenFrame: {
      color: 0,
    },
    option: {
      id: null, //$productOptionSelect.val(),
    },
    extraOption: {},
    passepartoutOptions: {
      color: 0,
      frameWidth: 2, // default = 2cm
      passepartoutWidth: 3, // default = 3cm
    },
    fineArtPaperOptions: {
      whiteBorder: 1,
    },
    moreOptions: 0,
    url: '',
    name: '',
  },
};
const displayErrorMessage = function () {
  $('.c-product-customizer__error').fadeIn('slow');
};
const hideErrorMessage = function () {
  $('.c-product-customizer__error').fadeOut('slow');
};
// Check if the selected product has a Wooden Frame or not
const hasWoodenFrame = function () {
  return selectedProductValues.woodenFrameColor.id != null &&
    selectedProductValues.woodenFrameColor.id != 0;
};

const hasSideLongerThan = function (length) {
  const photoLongestSize = Math.max(
    selectedProductValues.size.targetCmWidth,
    selectedProductValues.size.targetCmHeight,
  );
  return photoLongestSize > length;
};

const setAcrylicGlassFinish = function () {
  // If the selected product is not acrylic glass, do nothing
  if (selectedProductValues.type.id != '2') {
    return;
  }
  let lamination_glossy_id = 2;
  let lamination_matte_id = 3;

  let acrylicGlassOptionId;
  // if it's an acrylic glass and has a wooden frame, set always finish glossy
  if (hasWoodenFrame()) {
    acrylicGlassOptionId = lamination_glossy_id;
    $(".product-options-container").hide();
  }
  else {
    acrylicGlassOptionId = $(`${productOptionSelect}:checked`).val();
    $(".product-options-container").show();
  }
  selectedProductValues.option.id = acrylicGlassOptionId;

}

const setCanvasFrameThickness = function () {
  // If the selected product is not canvas, do nothing
  if (selectedProductValues.type.id != '3') {
    return;
  }

  let canvasOptionId = 4;
  /*
  if (hasSideLongerThan(90)) {
    canvasOptionId = 5; // thickness 4cm
  } else {
    canvasOptionId = 4; // thickness 2cm
  }
  // If it's a canvas and has a wooden frame, set always 2 cm thickness
  if (hasWoodenFrame()) {
    canvasOptionId = 4; // thickness 2cm
  }
  */

  selectedProductValues.option.id = canvasOptionId;
};

const setActualProduct = function () {
  // This shouldn't really go here, but the way it is now it's probably the best place
  setCanvasFrameThickness();
  setAcrylicGlassFinish();

  let inputData = {
    photo_id: photo_id,
    product_type_id: selectedProductValues.type.id,
    product_size_id: selectedProductValues.size.id,
    product_option_id: selectedProductValues.option.id,
    wooden_frame_color_id: selectedProductValues.woodenFrameColor.id
  };

  makeBuyButtonDisabled();
  fetch(siteurl + "ajaxBuy/product", {
    method: 'post',
    body: JSON.stringify(inputData),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Errore HTTP: ' + response.status);
    }
    return response.json();
  }).then((res) => {
    if (res.status == 'ok') {
      //console.log("ok");
      productExists = true;
      hideErrorMessage();

      selectedProductValues.actualProduct.id = res.product_id;
      selectedProductValues.actualProduct.price = res.costs.price;

      if (hasWoodenFrame()) {
        selectedProductValues.actualProduct.withWoodenFrame = 1;
      }
      else {
        selectedProductValues.actualProduct.withWoodenFrame = 0;
      }

      costs = res.costs;
      costs.price_before_discount = res.original_price;
      makeBuyButtonEnabled();
      displayCosts();
    }
    else {
      // product not found
      //console.log("error");
      productExists = false;
      displayErrorMessage();
      makeBuyButtonDisabled();
      return;
    }

  }).catch((error) => {
    console.log(error)
  })

  /*
  let product = prices.filter(el => el.product_type_id == selectedProductValues.type.id &&
    el.product_size_id == selectedProductValues.size.id &&
    el.product_option_id == selectedProductValues.option.id);

  if (product.length) {
    product = product[0];
    productExists = true;
    hideErrorMessage();
  } else {
    productExists = false;
    displayErrorMessage();
    return;
  }

  selectedProductValues.actualProduct.id = product.product_id;
  selectedProductValues.actualProduct.price = product.costs.without_frame.price;


  if (hasWoodenFrame()) {
    if (product.costs.with_frame == null ||
      (product.costs.with_frame != null && product.costs.with_frame.price <= 0)) {
      productExists = false;
      displayErrorMessage();
      return;
    }
    selectedProductValues.actualProduct.withWoodenFrame = 1;
    selectedProductValues.actualProduct.priceWithWoodenFrame = product.costs.with_frame.price;

    costs = product.costs.with_frame;
  } else {
    selectedProductValues.actualProduct.withWoodenFrame = 0;
    costs = product.costs.without_frame;
  }
    */
};
/* Hide the container with all the product options every time a new product is selected */
const showAllCurrentProductOptions = function () {
  $('.photo-page-all-options-wrap').removeClass('is-hidden');
};
const updateProductSizes = function () {
  loadProductSizesTemplate();
};
const showWhiteBorder = function () {
  if (selectedProductValues.type.id == 4) {
    if (selectedProductValues.extraOption.id == 7) {
      $wallPicture.addClass('with-white-border');
    } else {
      $wallPicture.removeClass('with-white-border');
    }
  }
};
const setExtraFrameSize = function (extra_width, extra_height) {
  let w1 = selectedProductValues.size.targetCmWidth;
  let h1 = selectedProductValues.size.targetCmHeight;

  let w2 = w1 * 1 + extra_width;
  let h2 = h1 * 1 + extra_height;

  $("#framed-print-internal-size").html(w1 + " x " + h1);
  $("#framed-print-external-size").html(w2 + " x " + h2);
  $("#framed-print-size-msg").show();
}
const setPassepartoutFrameOptions = function () {

  // at the moment this check is necessary, but we should remove it
  if (selectedProductValues.type.id == 7) {

    setExtraFrameSize(10, 10);

    const passepartoutOptions = allProductOptions['framed-poster'].product_passepartout_options;
    const $selectedPassepartoutColor = $(`${passepartoutFrameColorSelect}:checked`);
    const colorId = $selectedPassepartoutColor.val();
    const colorLabel = $selectedPassepartoutColor.data('color-label');

    selectedProductValues.passepartoutFrameColor.id = colorId;
    selectedProductValues.passepartoutFrameColor.text = colorLabel;
    selectedProductValues.passepartoutFrameColor.slug = $selectedPassepartoutColor.data('color-slug');

    $('.product-passepartout-options-selected-option-name').html(colorLabel);


    //if (hasSideLongerThan(90)) {
    //  photoOptions.product.passepartoutOptions.frameWidth = 4;
    //  photoOptions.product.passepartoutOptions.passepartoutWidth = 5;
    //} else {
    photoOptions.product.passepartoutOptions.frameWidth = 2;
    photoOptions.product.passepartoutOptions.passepartoutWidth = 3;
    //}

    const passepartoutSubOptionFilter =
      `${photoOptions.product.passepartoutOptions.frameWidth}_${photoOptions.product.passepartoutOptions.passepartoutWidth}_${colorId}`;
    // filter returns an array, even if contains only one value
    // sub_options_combination = thickness-of-passepartout-frame, passepartout-size, passepartout-frame-color-id;
    const passepartoutOption = passepartoutOptions.filter(el => el.sub_options_combination == passepartoutSubOptionFilter);

    if (passepartoutOption.length) {
      selectedProductValues.option.id = passepartoutOption[0].id;
    } else {
      selectedProductValues.option.id = null;
    }
  }
};
const setWoodenFrameColor = function () {
  if (selectedProduct && selectedProduct.product_info.has_frame == 1) {
    const $selectedFrame = $(`${productFrameSelect}:checked`);
    const colorId = selectedProductValues.woodenFrameColor.id = $selectedFrame.val();
    let colorLabel;

    if (colorId == 0) {
      colorLabel = $selectedFrame.data('color-label');
    } else {
      colorLabel = selectedProduct.product_frame_colors[colorId].color_label;
    }

    selectedProductValues.woodenFrameColor.text = colorLabel;
    selectedProductValues.woodenFrameColor.slug = `color-${$selectedFrame.data('color-slug')}`;
  }
};
const setInitialSize = function () {
  const middleSizeIndex = 0; //Math.ceil($productSizeSelect.children().length / 2) - 1;
  $productSizeSelect.find('option').eq(middleSizeIndex).prop('selected', 'selected');
  selectedProductValues.size.id = $productSizeSelect.val();
};
const setPreviousSelectedSize = function () {
  const sizeExists = $productSizeSelect.find('option').filter(function () {
    return selectedProductValues.size.id == $(this).val();
  }).length;

  if (sizeExists) {
    $productSizeSelect.val(selectedProductValues.size.id).prop('selected', 'selected');
  } else {
    setInitialSize();
  }
};
const setProductSize = function () {
  const selectedSize = $productSizeSelect.find('option:selected');
  selectedProductValues.size.id = selectedSize.val();
  const ratio = 1.9;


  selectedProductValues.size.targetCmHeight = selectedSize.data('cm-height');
  selectedProductValues.size.targetCmWidth = selectedSize.data('cm-width');
  selectedProductValues.size.targetHeight = selectedSize.data('cm-height') * ratio;
  selectedProductValues.size.targetWidth = selectedSize.data('cm-width') * ratio;
  selectedProductValues.size.unit = selectedSize.data('unity-of-measurement');

  if (selectedProductValues.unit === 'inches') {
    // let's convert from inches to cm
    selectedProductValues.targetCmHeight *= 2.54;
    selectedProductValues.targetCmWidth *= 2.54;
    selectedProductValues.targetHeight *= 2.54;
    selectedProductValues.targetWidth *= 2.54;
  }
};

const setProductType = function () {
  const selectedProductType = $('.select-product-type:checked');
  // when changing product we have to reset the options
  let selectedProductTypeSlug = productTypes[selectedProductType.val()];

  // if the page has a default product type, prevent from changing it
  // showProductTypes is a variable created in "photo" and "customize_print_photo" views
  if (!showProductTypes) {
    selectedProductTypeSlug = defaultProductSlug;
  }

  // global object with the selected product object
  selectedProduct = allProductOptions[selectedProductTypeSlug];

  if ($("#delivery-times-js").length > 0 && typeof selectedProduct !== "undefined")
    $("#delivery-times-js").html(selectedProduct.production_times);

  if (selectedProduct)
    selectedProductValues.type.id = selectedProduct.product_info.id;
};

const showFrameWithPassepartoutOnPicture = function () {
  $wallPicture.addClass('with-passepartout-frame');
  $wallPicture.removeClass((index, className) => (className.match(/(^|\s)passepartout-frame-\S+/g) || []).join(' '));
  $wallPicture.addClass(selectedProductValues.passepartoutFrameColor.slug);
};
const setProductOption = function () {
  $("#framed-print-size-msg").hide();

  if (selectedProductValues.type.id == '2') { // acrylic glass
    setAcrylicGlassFinish();
  }
  else if (selectedProductValues.type.id == '3') { // canvas
    setCanvasFrameThickness();
  }
  // todo: move this in the object with all the others
  else if (selectedProductValues.type.id == '7') { // framed poster
    setPassepartoutFrameOptions();
    showFrameWithPassepartoutOnPicture();
  }

  // if product is not canvas nor framed poster
  if (selectedProductValues.type.id != '3'
    && selectedProductValues.type.id != '7') {
    const $selectedOption = $(`${productOptionSelect}:checked`);
    selectedProductValues.option.id = $selectedOption.val();
    selectedProductValues.option.text = $selectedOption.data('text');
  }
};
const setProductExtraOption = function () {
  const $selectedExtraOption = $(`${productExtraOptionSelect}:checked`);
  selectedProductValues.extraOption.id = $selectedExtraOption.val();
  selectedProductValues.extraOption.text = $selectedExtraOption.data('text');
  if (selectedProductValues.type.id == 4) { // if fine art paper
    showWhiteBorder();
  }
};
const showSelectedOptions = function () {
  // var productType = selectedProductValues.type.name;
  $('.selected-extra-option-text').text(selectedProductValues.extraOption.text);
  $('.selected-option-text').text(selectedProductValues.option.text);
  $('.selected-wooden-frame-color').text(selectedProductValues.woodenFrameColor.text);
};
const showFrameOptions = function () {
  if (photoOptions.product.availableWithFrame
    && currency !== 'USD') {
    $('#product-frame-row').removeClass('is-hidden');
  } else if (photoOptions.product.availableWithFrame == 0) {
    $('#product-frame-row').addClass('is-hidden');
    $('#select-product-frame').val(0);
    photoOptions.product.woodenFrame.color = 0;
  }
};
const resetPhotoDisplayOptions = function () {
  // fine art paper
  $wallPicture.removeClass('with-white-border');

  // wooden frames
  $wallPicture.removeClass('with-wooden-frame');
  $wallPicture.removeClass((index, className) => (className.match(/(^|\s)color-\S+/g) || []).join(' '));

  // passepartout frames
  $wallPicture.removeClass('with-passepartout-frame');
  $wallPicture.removeClass((index, className) => (className.match(/(^|\s)passepartout-frame-\S+/g) || []).join(' '));
};
const showWoodenFrameOnPicture = function () {
  if (selectedProductValues.woodenFrameColor.id == 0) {
    $wallPicture.removeClass('with-wooden-frame');
  } else {
    $wallPicture.addClass('with-wooden-frame');
    $wallPicture.removeClass((index, className) => (className.match(/(^|\s)color-\S+/g) || []).join(' '));
  }
  $wallPicture.addClass(selectedProductValues.woodenFrameColor.slug);
};
const showFrameOnPicture = function () {
  if (photoOptions.product.typeId == 7) {
    showFrameWithPassepartoutOnPicture();
  } else if (photoOptions.product.availableWithFrame) {
    showWoodenFrameOnPicture();
  }
};
const resizePhotoPreview = function () {
  /*
  const maxWidth = 500;
  const maxHeight = 250;

  let { targetWidth, targetHeight } = selectedProductValues.size;
  
  const imageWidth = wallPictureOriginalW;
  const imageHeight = wallPictureOriginalH;

  let scaleFactor = 0;
  if (targetWidth > maxWidth) {
    scaleFactor = maxWidth / targetWidth;
    targetWidth = maxWidth;
    targetHeight *= scaleFactor;
  }

  const ratio = Math.min(targetWidth / imageWidth, targetHeight / imageHeight);

  const newWidth = imageWidth * ratio;
  const newHeight = imageHeight * ratio;
  */
  let couchWidthCm = 180;
  let couchWidthPx = $photoOnWallContainer.width();
  let selectedWidthCm = selectedProductValues.size.targetCmWidth;
  let selectedWidthPx = couchWidthPx * selectedWidthCm / couchWidthCm;
  let pictureWidthAsPercentage = selectedWidthPx / $photoOnWallContainer.width() * 100;

  $wallPicture.css('width', pictureWidthAsPercentage + '%');
  $wallPicture.css('height', 'auto');
};
const setCurrency = function () {
  currency = $('#page-data').data('current-currency');
};
const toggleButtonStatus = function () {
  if (productExists) {
    makeBuyButtonEnabled();
  } else {
    makeBuyButtonDisabled();
  }
};
const makeBuyButtonEnabled = function () {
  $('.js-buy-button').tooltipster('disable');
  $('.js-buy-button').removeClass('is-inactive');
  $('.c-button__price').removeClass('is-hidden');
}

const makeBuyButtonDisabled = function () {
  $('.js-buy-button').tooltipster('enable');
  $('.js-buy-button').addClass('is-inactive');
  $('.c-button__price').addClass('is-hidden');
}

const afterProductsLoaded = function () {
  setDefaultProductOptions();
  loadProductOptionsTemplate();
  loadProductSizesTemplate();
  //loadProductTypesGridTemplate();
  loadProductTypesTooltipTemplate();
  //loadProductTypesSidebarTemplate();

  $('.tooltip').tooltipster({
    side: ['top', 'left', 'bottom'],
    contentAsHTML: true,
    interactive: true,
    theme: 'tooltipster-borderless',
  });

  $('.js-buy-button').tooltipster({
    trigger: 'click',
    contentAsHTML: true,
    interactive: true,
    theme: 'tooltipster-borderless',
  });

  setInitialSize();
  setProductSize();

  resizePhotoPreview();
};
const showInitialProduct = function () {
  resetOptions();
  resetPhotoDisplayOptions();
  showAllCurrentProductOptions();
  setProductType();
  updateProductSizes();
  setPreviousSelectedSize();
  setProductSize();
  loadProductOptionsTemplate();
  setProductOption();
  setProductExtraOption();

  setWoodenFrameColor();

  setActualProduct();
  productExists = true;
  toggleButtonStatus();
  displayCosts();
  showSelectedOptions();
};
const setProductTypeOptions = function () {
  showFrameOnPicture();
  setPassepartoutFrameOptions();
};
const onSizeChange = function () {
  // disableOptions();
  setProductSize();
  setProductTypeOptions();
  setProductOption();
  resizePhotoPreview();
  showFrameOptions();
  showFrameOnPicture();
  triggerSliderChange();
  setActualProduct();
  toggleButtonStatus();
  displayCosts();
  displayPrintQuality();
};
const onProductTypeChange = function () {
  resetOptions();
  resetPhotoDisplayOptions();
  showAllCurrentProductOptions();
  triggerSliderChange();

  setProductType();

  updateProductSizes();
  setPreviousSelectedSize();

  setProductSize();
  loadProductOptionsTemplate();
  setProductOption();
  setProductExtraOption();

  setWoodenFrameColor();

  setActualProduct();
  toggleButtonStatus();
  displayCosts();
  showSelectedOptions();
  loadProductVideoTemplate();
};
const onProductOptionChange = function () {
  setProductOption();
  setActualProduct();
  toggleButtonStatus();
  displayCosts();
  showSelectedOptions();
};
const onProductExtraOptionChange = function () {
  setProductExtraOption();
  showWhiteBorder();
  showSelectedOptions();
  displayCosts();
};
const onWoodenFrameChange = function () {
  setWoodenFrameColor();
  showWoodenFrameOnPicture();
  setActualProduct();
  toggleButtonStatus();
  displayCosts();
  showSelectedOptions();
  setExtraFrameSize(4.6, 4.6);
};
const onPassepartoutFrameColorChange = function () {
  setPassepartoutFrameOptions();
  showFrameWithPassepartoutOnPicture();
  setActualProduct();
  toggleButtonStatus();
  displayCosts();
};

const setTotalDonation = function () {
  // TODO: this can be done better
  if (!isPrintPhotoPage) {
    let treesPlanted = Math.ceil(costs.total_donation / treeCost);
    displayTreeNumberElement.textContent = treesPlanted;
  }
};
const displayPrintQuality = function () {
  const selectedSize = $productSizeSelect.find('option:selected');
  const quality = selectedSize.data('quality');
  if (quality >= 1 && quality <= 5) {
    for (let i = 1; i <= quality; i++) {
      $(`#print-quality-star-${i}`).removeClass('fa-star-o empty').addClass('fa-star full');
    }
    for (let i = quality + 1; i <= 5; i++) {
      $(`#print-quality-star-${i}`).addClass('fa-star-o empty').removeClass('fa-star full');
    }
  }
};

photoData = photo.photo;
$('#submit-to-cart-button').click(function (e) {
  if ($(this).hasClass('is-inactive')) {
    return false;
  }
  track_addToCartPhotoItem(costs.price);
  e.preventDefault();
  $('#submit-to-cart').submit();
});

$('.js-see-photo-fullscreen').click(() => {
});


$window.on('load', () => {
  init();
});

const init = function () {
  if (isPrintPhotoPage) {
    $("#loading-bodyclick").show();
    $.post(
      `${siteurl}ajax/generate_thumbnails`,
      { id: $("#photo-id-submit").val() },
      (data) => {
        if (data.status == 'ok') {
          $("#photo-on-wall").attr('src', data.thumbnail_url);
          $(".photo-fullscreen").attr('src', data.thumbnail_url);
          $("#custom-print-img").attr('src', data.original_thumbnail_url);
          initCropperIfNecessary();
          $("#loading-bodyclick").hide();
          initAfterLoad();
        }
        else {
          // something went wrong during the generation of the thumbnails
        }

      }, 'json'
    );
    return;
  }
  else {
    initAfterLoad();
  }
}

const initAfterLoad = function () {
  wallPictureOriginalW = $wallPicture[0].naturalWidth;
  wallPictureOriginalH = $wallPicture[0].naturalHeight;
  afterProductsLoaded();
  initSidebar();
  showInitialProduct();
  loadProductVideoTemplate();
  initializeProducts();
  initializeProductDetails();
}

setCurrency();
$('.js-photo-thumb-nav').click(changeSliderItem);

Handlebars.registerHelper('ifCond', function (v1, v2, options) {
  if (v1 == v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});


$productSizeSelect.change(onSizeChange);
$('.photo-page-product-option-wrap').on('change', productTypeSelect, onProductTypeChange);
$('.photo-page-all-options-wrap').on('change', productOptionSelect, onProductOptionChange);
$('.photo-page-all-options-wrap').on('change', productExtraOptionSelect, onProductExtraOptionChange);
$('.photo-page-all-options-wrap').on('change', productFrameSelect, onWoodenFrameChange);
$('.photo-page-all-options-wrap').on('change', passepartoutFrameColorSelect, onPassepartoutFrameColorChange);
